import React, { useEffect, useState} from "react";
import { BsCartFill} from "react-icons/bs";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import Sheet from 'react-modal-sheet';
import {alert, confirm} from "../components/MegConfirmAlert";
import Product3 from "../components/Product3";
import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';
import { getCartCookie } from "../services/common";
import boxOpen from "../images/boxOpen.svg";
import Modal from 'react-bootstrap/Modal';

export default function ProdList (props){

    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [optionList, setOptionList] = useState([]);
    const [selOptionList, setSelOptionList] = useState([]);
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios();
    const [totalAmt, setTotalAmt] = useState(0);
    const [amtList, setAmtList] = useState([]);
    const [isOpen, setOpen] = useState(false);
    //3만원 구매 팝업
    const [modalShow, setModalShow] = useState(false);
    useEffect(() => {
        if(props.prodOpen){
            fetchData();
        }        
    }, [props.prodOpen]);

 
    const checkOrderCnt = (obj,checkCnt) => {


        if(obj.soldoutAt === "Y"){
            return false
        }

        const cnt = amtList.find(item=>item.goodsOptnSn===obj.goodsOptnSn)?amtList.find(item=>item.goodsOptnSn===obj.goodsOptnSn).orderQy:0        
        const goodsCnt = amtList.filter(item=>item.goodsSn===obj.goodsSn)?(amtList.filter(item=>item.goodsSn===obj.goodsSn).reduce((accum,item) => accum + item.orderQy, 0)):0
       

        const goodsBuyLimitOptionCode = data.goodsInfo?.goodsBuyLimitOptionCode?data.goodsInfo?.goodsBuyLimitOptionCode:''
        if(goodsBuyLimitOptionCode){
            let goodsBuyLimitValue = data.goodsInfo?.goodsBuyLimitValue?data.goodsInfo?.goodsBuyLimitValue:0
            const goodsBuyCnt = data.goodsBuyCnt?data.goodsBuyCnt:0        
            goodsBuyLimitValue = goodsBuyLimitValue - goodsBuyCnt

            if(goodsBuyLimitValue < (goodsCnt+checkCnt)){
                alert("상품 구매가능개수를 초과하였습니다.")
                return false
            }
        }

        const buyLimitOptionCode = obj?.buyLimitOptionCode?obj?.buyLimitOptionCode:''
        if(buyLimitOptionCode){
            let buyLimitValue = obj?.buyLimitValue?obj?.buyLimitValue:0
            const optnBuyCnt = obj?.optnBuyCnt?obj?.optnBuyCnt:0
            buyLimitValue = buyLimitValue - optnBuyCnt

            if(buyLimitValue < (cnt+checkCnt)){
                console.log(buyLimitValue)
                alert("상품 옵션 구매가능개수를 초과하였습니다.")
                return false
            }
        }

        return true
    }
    

    const fetchData = async () => {        
        const response = await request.post("/app/goods/getGoodsOptnInfoListAPI", {
            nationSeCode : lang,
            goodsSn : props.id,
        });

        if(response.data.resultCode === 200){           
            setData(response.data.result)           
            setOptionList(response.data.result.goodsOptnInfoList || []);
        }
    };

    const ConfirmCart = async () => {
        const cnt = amtList.reduce((accum,item) => accum + item.orderQy, 0)
        if(cnt === 0){
            alert(t(`Message.add_cart_bottom_sheet_add_optn_qy_msg`));  
            return;
        }
        let tmprOrderList = [];
        amtList.forEach(function (value, index) {
            if(value.orderQy !== 0){
                tmprOrderList.push(value);
            }
        });
        var cartCookie = getCartCookie()
        const response = await request.post("/app/cart/addGoodsInCartAPI", {
            cartCookie : cartCookie,
            tmprOrderList : tmprOrderList
        });        
        if(response.data.resultCode === 200){      
            props.setProdOpen(false)      
            const result = await confirm(t(`Message.add_cart_result_put_goods_cart`), {okText : t(`Message.add_cart_result_move_cart`) , cancelText : t(`Message.add_cart_result_continue_shopping`)});
            if(result){
                window.location.href="/cart";
            }
        }    
    }

    const fn_moveOrder = (check) => {
        const cnt = amtList.reduce((accum,item) => accum + item.orderQy, 0)
        if(cnt === 0){
            alert(t(`Message.add_cart_bottom_sheet_buy_optn_qy_msg`));  
            return;
        }

        if(optionList && optionList.length && optionList.length === 1){
            if(!checkOrderCnt(optionList[0],0)){
                return
            }
        }else{
            let checkCnt =  selOptionList.every(function (value, index) {
                return checkOrderCnt(value,0)                
            })
           

            if(!checkCnt){
                return
            }                
        }

        if(check!== true && totalAmt < 30000){
            setModalShow(true)

        }else{

            let orderList = [];
            amtList.forEach(function (value, index) {
                if(value.orderQy !== 0){
                    value.cartAt = 'N'
                    orderList.push(value);
                }
            });

            navigate('/Order', {
                state: { from: orderList },
            })
        }
    }

    useEffect(() => {
      
        const total = amtList.reduce((accum,item) => accum + item.amt, 0)        
        setTotalAmt(total);   
    }, [amtList]);


    function onSetTotalAmt(amt,key) {

        let tempList = amtList.filter((el) => el.goodsOptnSn !== key)
        tempList.push(amt)        
        setAmtList(tempList)
                
        
    }

    const fn_clickSelect = (obj) => {     
        if(!checkOrderCnt(obj,1)){
            return
        }    
        const idx = selOptionList.findIndex(function(item) {return item.goodsOptnSn === obj.goodsOptnSn});            
        if (idx > -1)  {         
                 
            setAmtList(amtList.map((v,i)=>{
                if (v.goodsOptnSn !== amtList[i].goodsOptnSn) {
                  return v
                } else {
                  return { ...v, orderQy:v.orderQy+1 }
                }
              }))                  
        }else{
            selOptionList.push(obj)
            
        }
        setOpen(false)
    }

    const fn_btnXClick = (obj) =>{        
        setSelOptionList(selOptionList.filter((el) => el.goodsOptnSn !== obj.goodsOptnSn));        
        setAmtList(amtList.filter((el) => el.goodsOptnSn !== obj.goodsOptnSn));
        
    }

    const fn_close = () => {
        setSelOptionList([])
        setAmtList([])
        setTotalAmt(0)
        setOpen(false)
        props.setProdOpen(false)
    }

    return (
        <>
        <Sheet isOpen={props.prodOpen} onClose={fn_close} className="bottomModal">
            <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
                <div className="modalProdList">
                {optionList && optionList.length && optionList.length === 1 ?(
                    <>                    
                        <Product3 type="type9" 
                        prodName={optionList[0].firstOptnNm + optionList[0].firstOptnValue}
                        cost={"￦"+(!optionList[0].nrmltAmount?0:optionList[0].nrmltAmount).toLocaleString('ko-KR')}
                        disprice={"￦"+(!optionList[0].sleAmount?0:optionList[0].sleAmount).toLocaleString('ko-KR')}
                        sleQy = {(!optionList[0].sleQy?0:optionList[0].sleQy).toLocaleString('ko-KR')}
                        red={optionList[0].sleQy > 0 && optionList[0].sleQy <= 10}
                        blue={optionList[0].sleQy > 10}
                        soldOut={optionList[0].soldoutAt==="Y" || optionList[0].sleQy <= 0}
                        obj = {optionList[0]}
                        checkOrderCnt = {checkOrderCnt}
                        setTotalAmt={onSetTotalAmt}
                        cnt ={1}
                        />
                    </>
                ) : (
                
                    <>
                    <div className="prodType7">
                        <div className="selectBox">
                            <button type="button" className="selectOpen" onClick={(e)=>setOpen(!isOpen)} >상품을 선택해주세요</button>
                            {isOpen?(
                                 <ul className="selectList">
                                    {optionList && optionList.map((obj, index) => (   
                                        <Product3 type="type7" key={index}
                                        prodName={obj.firstOptnNm + obj.firstOptnValue}
                                        cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                                        disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                                        sleQy = {(!obj.sleQy?0:obj.sleQy).toLocaleString('ko-KR')}
                                        red={obj.sleQy > 0 && obj.sleQy <= 10}
                                        blue={obj.sleQy > 10}
                                        soldOut={obj.soldoutAt==="Y" || obj.sleQy <= 0}
                                        checkOrderCnt = {checkOrderCnt}
                                        obj = {obj}   
                                        clickSelect={fn_clickSelect}                                    
                                        />
                                    ))}      
                                 </ul>
                            ):(
                                <>
                                {selOptionList && selOptionList.map((obj, index) => (  
                                    <Product3 type="type9" key={index}
                                    prodName={obj.firstOptnNm + obj.firstOptnValue}
                                    cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                                    disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                                    sleQy = {(!obj.sleQy?0:obj.sleQy).toLocaleString('ko-KR')}
                                    red={obj.sleQy > 0 && obj.sleQy <= 10}
                                    blue={obj.sleQy > 10}
                                    soldOut={obj.soldoutAt==="Y" || obj.sleQy <= 0}
                                    checkOrderCnt = {checkOrderCnt}
                                    obj = {obj}      
                                    setTotalAmt={onSetTotalAmt}
                                    cnt={amtList.find(item=>item.goodsOptnSn===obj.goodsOptnSn)?amtList.find(item=>item.goodsOptnSn===obj.goodsOptnSn).orderQy:1}     
                                    btnX = {true}  
                                    btnXClick={fn_btnXClick}                       
                                    />
                                ))}      
                                </>
                            )}
                        </div>
                    </div>
                    
                    
                    </>
                )}


                
                </div>
                <div className="btnWr">
                    <button type="button" className="cartBtn" onClick={ConfirmCart}><BsCartFill /></button>
                    <button type="button" className="buyBtn" onClick={fn_moveOrder}>￦{totalAmt.toLocaleString('ko-KR')} {t(`Message.add_cart_bottom_sheet_buying`)}</button>
                </div>
            </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onClick={fn_close}/>
        </Sheet>
       
        <Modal 
            className="btModal"
            show={modalShow}
            onHide={() => setModalShow(false)}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            
            <div className="cgrModal">
            <div className="cgrMent">
                    <p className="cBlue">3만원 무료배송 혜택을 받으려면</p>
                    <p className="cBlack">￦{(30000-totalAmt).toLocaleString('ko-KR')} 더 담으면 됩니다.</p>
                </div>
                <img src={boxOpen} alt="." />
                <div className="cgrMent">
                    <p className="cBlack">계속 쇼핑 하시겠습니까?</p>
                </div>
            </div>
            <div className="cgrModalBtnWr more">
                <div className="dfcsG6 w100per">
                    <button type="button" className="cartBtn" onClick={(e)=> { setModalShow(false); ConfirmCart()}}><BsCartFill /></button>
                    <button type="button" className="btn40 orgB cFFF" onClick={(e)=> fn_moveOrder(true)}>결제하러 가기</button>
                </div>
                <button onClick={() =>  setModalShow(false)} className="cDisa">{t(`Message.add_cart_result_continue_shopping`)}</button>
            </div>
        </Modal>
    </>
    );

};